export function linkToDashboardPage() {
  return "/dashboard";
}
